const e=(e,t)=>e?Object.entries(e).reduce(((e,[c,r])=>(t(r)||(e[c]=r),e)),{}):{};export{e as omitBy};
//# sourceMappingURL=omitBy.js.map
